import { Button } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import axios from "axios";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";
import "./Result.css";

const Result = ({ name, score, quiz, section, activities, correctQuestions, resultID }) => {
  const [error, setError] = useState(false);
  const totalCorrectQuestions = [...new Set(correctQuestions)].length;
  let scoreToSave = score !== totalCorrectQuestions ? totalCorrectQuestions : score;
  scoreToSave = score === (totalCorrectQuestions + 1) ? (totalCorrectQuestions + 1) : scoreToSave;

  const history = useHistory();

  useEffect(() => {
    if (!name) {
      history.push("/");
    }
  }, [name, history]);

  useEffect(() => {
    const saveResult = async (name, section, quiz, score, resultID) => {
      try {
        await axios.patch(`https://computer-quiz-backend.herokuapp.com/quizzes/${quiz}/results/${resultID}`, {
          full_name: name,
          year_section: section,
          score: scoreToSave,
          activities
        });
      } catch (e) {
        setError(e?.response?.data);
      }
    }
    if (name && section && quiz && (score || score === 0)) {
      saveResult(name, section, quiz, score, resultID);
    }
  }, [name, section, quiz, score, activities, totalCorrectQuestions, resultID, scoreToSave]);

  return (
    <div className="result">
      { error && <ErrorMessage>{error}</ErrorMessage> }
      <span style={{ fontSize: 35 }}>{name}</span>
      <span className="final">{ localStorage.getItem('quiz') } </span>
      <span className="score">{scoreToSave}</span>
      <Button
        variant="contained"
        color="secondary"
        size="large"
        style={{ alignSelf: "center", marginTop: 40 }}
        href="/"
      >
        Go to homepage
      </Button>
    </div>
  );
};

export default Result;
